import { render, staticRenderFns } from "./BindCardForm.vue?vue&type=template&id=2d33049f"
import script from "./BindCardForm.vue?vue&type=script&lang=js"
export * from "./BindCardForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports